import { createAction, props } from '@ngrx/store'
import { SelectionPayload } from '../../models/selection.models'
import { Team } from '@core/models/team.models'
import { Player } from '@core/models/player.models'
import { Competition, MatchDayData, Season } from '@core/models/season-competition.models'
import { EntitySelectionDemarcation } from '../../models/entity-selector.models'
import { CallingContext } from '@features/seasons/models/seasons.models'

export const setSelectionSeason = createAction('[Selection] set selection season', props<{ season: Season }>())
export const setSelectionCompetition = createAction(
  '[Selection] set selection teams',
  props<{ competition: Competition }>()
)

export const fetchSelectionTeams = createAction(
  '[Selection] fetch selection teams',
  props<SelectionPayload & { callingContext?: CallingContext }>()
)
export const setSelectionTeams = createAction('[Selection] set selection teams', props<{ teams: Team[] }>())
export const setSelectionTeamsLoader = createAction(
  '[Selection] set selection teams loader',
  props<{ teamsLoading: boolean }>()
)

export const fetchSelectionPlayers = createAction('[Selection] fetch selection players', props<SelectionPayload>())
export const setSelectionPlayers = createAction('[Selection] set selection players', props<{ players: Player[] }>())
export const setSelectionPlayersLoader = createAction(
  '[Selection] set selection players loader',
  props<{ playersLoading: boolean }>()
)

export const setSelectionPosition = createAction(
  '[Selection] set selection position',
  props<{ demarcation: EntitySelectionDemarcation }>()
)

export const purgeSelections = createAction('[Selection] purge selections')

export const purgeCommonSelections = createAction('[Selection] purge common selections')

export const fetchSelectionCommonMatchDays = createAction(
  '[Selection] fetch selection common match days',
  props<{ season: Season; competition: Competition }>()
)

export const setSelectionCommonSeason = createAction(
  '[Selection] set selection common season',
  props<{ commonSeason: Season }>()
)
export const setSelectionCommonCompetition = createAction(
  '[Selection] set selection common competition',
  props<{ commonCompetition: Competition }>()
)

export const setSelectionCommonMatchDays = createAction(
  '[Selection] set selection common matchDays',
  props<{ commonMatchDays: MatchDayData[] }>()
)

export const setSelectionCommonLastDayWithMatches = createAction(
  '[Selection] set selection common last day with matches',
  props<{ commonLastMatchDayIdWithMatches: string }>()
)

export const purgeSelectionCommonMatchDays = createAction('[Selection] purge selection common match days')
